import { render, staticRenderFns } from "./ThankYouGroup.vue?vue&type=template&id=524b1a14&scoped=true&"
import script from "./ThankYouGroup.vue?vue&type=script&lang=js&"
export * from "./ThankYouGroup.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouGroup.vue?vue&type=style&index=0&id=524b1a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b1a14",
  null
  
)

export default component.exports